import React from 'react';
import { ErrorImgWrapper, ErrorTextWrapper } from './ErrorComponent.styles';
import ErrorImg from './ErrorImg';
var ErrorComponent = function () {
    return (React.createElement("div", null,
        React.createElement(ErrorImgWrapper, null,
            React.createElement(ErrorImg, null)),
        React.createElement(ErrorTextWrapper, { bg: 'warning.light', mx: 3, borderRadius: 12, py: 2, px: 12 },
            React.createElement("span", null, "Lost in the Clouds. "),
            " We're sorry, something seems to have gone wrong. Please try again in a little bit.")));
};
export default ErrorComponent;
//# sourceMappingURL=ErrorComponent.js.map